/** Admin: messages sent from the public Contact page. Read them, reply by email, mark them handled. */
import { api } from '../../core/api.js';
import { register } from '../../core/events.js';
import { html } from '../../core/html.js';
import { fmtDateTime } from '../../core/format.js';
import { reload } from '../../app/shell.js';
import { empty, pageHead, statusTag, who } from '../../ui/components.js';
import { toast } from '../../ui/toast.js';
import { PAGE, filterSelect, pager, queryOf } from './shared.js';

const enquiries = {
  path: '/admin/enquiries',
  roles: ['admin'],
  title: 'Enquiries',
  async load(ctx) {
    const query = queryOf(ctx);
    const { enquiries: list } = await api.get('/admin/enquiries', { signal: ctx.signal, query: { ...query, limit: PAGE } });
    return { list, query };
  },
  view({ list, query }) {
    return html`${pageHead('Enquiries', 'Messages from the Contact page. Reply from your own mailbox, then mark the message handled.')}
      <div class="row mb">${filterSelect('Show', 'status', [['new', 'Waiting for a reply'], ['handled', 'Handled']], query.status, 'Everything')}</div>
      ${list.length
        ? html`<div class="list">${list.map((m) => html`<article class="card" aria-label="Message from ${m.name}">
            <div class="row between">${who(m.name, m.email)}<span class="row sm">${statusTag(m.status === 'new' ? 'pending' : 'handled')}<span class="mu">${fmtDateTime(m.created_at)}</span></span></div>
            <p class="mt-s" style="white-space:pre-wrap;margin-bottom:12px">${m.message}</p>
            <div class="row"><a class="btn ghost sm" href="mailto:${m.email}?subject=${encodeURIComponent('Your message to VConnect')}">Reply by email</a>
              ${m.status === 'new' ? html`<button type="button" class="btn sm" data-act="enquiry.handled" data-id="${m.id}">Mark handled</button>` : ''}</div>
          </article>`)}</div>`
        : empty('chat', query.status === 'handled' ? 'Nothing handled yet' : 'No messages waiting', 'New messages from the Contact page show up here.')}
      ${pager('/admin/enquiries', query, list.length)}`;
  },
};

register({
  'enquiry.handled': async (el) => {
    await api.post(`/admin/enquiries/${el.dataset.id}/handled`);
    toast('Marked handled', 'check');
    await reload();
  },
});

export const routes = [enquiries];
